import React, { useState } from 'react';
import { FaKey, FaTimes } from 'react-icons/fa';

const PasswordResetModal = ({ user, onClose, onPasswordReset }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    try {
      setLoading(true);
      setError('');
      await onPasswordReset(user.id, newPassword);
      setSuccess('Password reset successfully');
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-reset-password-overlay">
      <div className="admin-reset-password-modal">
        <div className="admin-reset-password-header">
          <h2 className="admin-reset-password-title">Reset Password for {user.fullName}</h2>
          <button onClick={onClose} className="admin-reset-password-close">
            <FaTimes />
          </button>
        </div>

        {error && (
          <div className="admin-reset-password-alert admin-reset-password-alert-error">
            {error}
          </div>
        )}

        {success && (
          <div className="admin-reset-password-alert admin-reset-password-alert-success">
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit} className="admin-reset-password-form">
          <div className="admin-reset-password-form-fields">
            <div className="admin-reset-password-form-group">
              <label className="admin-reset-password-label">New Password</label>
              <div className="admin-reset-password-input-wrapper">
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="admin-reset-password-input"
                  placeholder="Enter new password"
                />
                <FaKey className="admin-reset-password-icon" />
              </div>
            </div>

            <div className="admin-reset-password-form-group">
              <label className="admin-reset-password-label">Confirm Password</label>
              <div className="admin-reset-password-input-wrapper">
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="admin-reset-password-input"
                  placeholder="Confirm new password"
                />
                <FaKey className="admin-reset-password-icon" />
              </div>
            </div>

            <div className="admin-reset-password-actions">
              <button
                type="button"
                onClick={onClose}
                className="admin-reset-password-button admin-reset-password-button-cancel"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="admin-reset-password-button admin-reset-password-button-submit"
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};


export default PasswordResetModal;